import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {BsLocaleService} from 'ngx-bootstrap';

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html'
})
export class LanguageSwitcherComponent implements OnInit {

  constructor(private translate: TranslateService, private localeService: BsLocaleService) {

  }

  ngOnInit() {
  }

  setLang(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
  }

}



// WEBPACK FOOTER //
// D:/Projects/mvdclick/frontend/src/app/components/language-switcher/language-switcher.component.ts